export const vendorList = ['photographer', 'mehendi', 'decorator']
export const vendorUrlPathLastValue = {
    photographer: "p",
}


export const PHOTOGRAPHER_MODEL = "photographer"
export const MEHENDI_ARTIST_MODEL = "mehandi_artist"
export const MAKE_UP_ARTIST_MODEL = "makeup_artist"
export const DECORATOR_MODEL = "decorator"
export const EVENT_PLANNER = "event_planner"
export const WEDDING_STYLIST = "wedding_stylist"
export const CATERERS = "caterer"
export const CHOREOGRAPHER = "choreographer"
export const DJ = "dj"
export const ANCHOR = "anchor"
export const WEDDING_ENTERTAINER = "wedding_entertainer"
export const PANDIT = "pandit"
export const CAR = "car"
export const BARTENDER = "bartender"
export const EVENT_EQUIPMENT = "event_equipment"

export const FAQ_JSON_TEMPLATE = JSON.stringify(
  {
    faqs: [
      {
        question: "Is parking available?",
        answer: "Yes, free parking is available."
      },
      {
        question: "Is outside food allowed?",
        answer: "No, outside food is not allowed."
      }
    ]
  },
  null,
  2
);

export const FAQ_CSV_TEMPLATE = `question,answer
Is parking available?,Yes free parking is available
Is outside food allowed?,No outside food is allowed
`;

export const QNA_JSON_TEMPLATE = JSON.stringify(
  {
    qnas: [
      {
        question: "What is the venue capacity?",
        answers: [
          {
            answer_text: "The venue can accommodate up to 300 guests.",
            user_name: "Anonymous",
            user_type: "agent"
          }
        ]
      },
      {
        question: "Is parking available at the venue?",
        answers: [
          {
            answer_text: "Yes, ample parking space is available for guests.",
            user_name: "Anonymous",
            user_type: "agent"
          }
        ]
      },
      {
        question: "Is outside catering allowed?",
        answers: [
          {
            answer_text: "No, outside catering is not permitted at this venue.",
            user_name: "Anonymous",
            user_type: "agent"
          }
        ]
      }
    ]
  },
  null,
  2
);

export const QNA_CSV_TEMPLATE = `question,answer_text,user_name,user_type
What is the venue Testing?,The venue can accommodate up to 300 guests.,Anonymous,agent
Is parking available at the Testing?,ample parking space is available for guests.,Anonymous,agent
Is outside catering Testing?,outside catering is not permitted at this venue.,Anonymous,agent
`;